import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 17H20M16 21L20 17L16 13M20 7H4M8 11L4 7L8 3",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgSwitchHorizontal;
